/* eslint-disable jsx-a11y/no-static-element-interactions */
// we have no direct interaction with static div element
// we're adding an ability to jump through all the input
// elements via "Enter" key
import { useRef, ReactNode, KeyboardEvent } from "react";

type Props = {
    children?: ReactNode;
};

export const Parameters = ({ children }: Props) => {
    const parametersPaneRef = useRef<HTMLDivElement>(null);

    const moveToNextInput = (event: KeyboardEvent) => {
        if (!parametersPaneRef.current || event.key !== "Enter") {
            return;
        }

        const inputElements = Array.from(parametersPaneRef.current
            .querySelectorAll("input:not([disabled])")) as HTMLInputElement[];

        const currentInputIndex = Array.from(inputElements).indexOf(event.target as HTMLInputElement);
        if (currentInputIndex < 0) {
            return;
        }

        const nextIndex = (currentInputIndex + 1) % inputElements.length;

        if (nextIndex !== currentInputIndex) {
            inputElements[nextIndex].focus();
        } else {
            // there is only one input child
            inputElements[nextIndex].blur();
        }
    };

    return (
        <div
            className="parameters-pane"
            ref={parametersPaneRef}
            onKeyDown={moveToNextInput}>
            {children}
        </div>
    );
};
